module.exports = __webpack_public_path__ + "b0490f4fbc47530c30053bc99c4350be.png";